import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { helpHttp } from "../../helper/helpHttp";
import { Tip } from "./Tip";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { changeLoading } from "../../redux/slices/category";
import { useNavigate } from "react-router-dom";

export const TIPSYRECOMENDACIONESID = "25";

export const TipsYRecomendaciones = () => {
  const navigate = useNavigate();
  const handleClose = () => {
    setCurrentVideo(null);
    navigate(1);
  };

  const [currentVideo, setCurrentVideo] = useState(null);

  const [data, setData] = useState([]);
  const { get } = helpHttp();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(changeLoading(true));
    get(`categorias/getDetailsCategoriaSinPdf/25`)
      .then((data) => {
        setData(data.datos);
      })
      .catch(() => toast.error("Ha ocurrido un error"))
      .finally(() => {
        dispatch(changeLoading(false));
      });
  }, []);

  return (
    <GridData>
      <StyledTips>
        {data.map((e) => {
          return (
            <Tip
              id={e.id}
              title={e.titulo}
              video={e.url_video}
              image={e.imagen}
              onClick={(e) => setCurrentVideo(e)}
              url_pdf={e.url_pdf}
              key={e.id}
            />
          );
        })}
      </StyledTips>

      <Dialog open={currentVideo} onClose={handleClose} maxWidth="md" fullWidth>
        <IconButton
          onClick={handleClose}
          style={{
            position: "absolute",
            right: 10,
            top: 10,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent style={{ padding: 0, height: "500px" }}>
          <iframe
            key={currentVideo ? "video-visible" : "video-hidden"}
            width="100%"
            height="100%"
            src={currentVideo}
            frameBorder="0"
            loading="lazy"
            sandbox="allow-scripts allow-same-origin"
            allow="fullscreen; picture-in-picture"
          />
        </DialogContent>
      </Dialog>
    </GridData>
  );
};

const GridData = styled.div``;
const StyledTips = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  gap: 75px;
  row-gap: 25px;

  > img {
    width: 100px;
  }
  > span {
    padding: 20px 50px;
  }
`;
